<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo"> 
      <i class="fas fa-users-cog icon"></i>
        Locaciones
      </div>
      
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul> 
            <li>
              <router-link :to="{name:'administrativeHome'}" >
                <span >
                  <i class="fas fa-home icon"></i>                  
                   inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{name: 'stablishment'}">
                <span>
                 <i class="fas fa-user-cog icon"></i>
                    Locaciones
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <div class="box">

          <createLocations 
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :closeBasic="closeBasic"
          :chargeListLocations="chargeListLocations"
          :location_id="location_id">
          </createLocations>
          <b-button type="is-primary is-small" @click="openBasic()">Crear Locacion</b-button>

          <b-table type="is-primary"
            :data.sync="listLocations"
            :loading="loading"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="location.name"
            aria-next-label="Next page"
            
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="id" label="ID" width="40" numeric>{{ props.row.id }}</b-table-column>

              <b-table-column field="name" label="Nombre">{{ props.row.name }}</b-table-column>

              <b-table-column label="Action">
                        <b-button type="is-primary is-small" @click="editBasic(props.row.id)">Editar</b-button>

              </b-table-column>
            </template>
          </b-table>
          
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from '../../../../template/PlantillaContenido'
import createLocations from '../../../../components/administrative/manteiners/location/create';

export default {
  components: {
    PlantillaContenido,
    createLocations
  },
  data() {
    return {
      location_id: null,
      listLocations: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5
    };
  },
  mounted: function() {
    this.chargeListLocations();
  },
  methods: {
    openBasic() {
      this.isComponentModalActive = true;
    },
    closeBasic() {
      this.location_id = null;
      this.isComponentModalActive = false;
    },
    editBasic(id) {
      this.location_id = id;
      this.isComponentModalActive = true;
    },
    chargeListLocations() {
      this.loading = true;
      this.listLocations = [];
      this.$http.get(`api/${localStorage.getItem('perfil')}/location`).then(
        response => {
          this.listLocations = response.body.data;
          this.loading = false;
        },
        response => {
          console.log("error: ", response);
        }
      );
    }
  },
  
};
</script>

